<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="名称">
                  <el-input  v-model="queryForm.menuName"></el-input>
              </el-form-item>
              <el-form-item label=" 类型">
<!--                  <el-input  v-model="queryForm.menuType"></el-input>-->
                  <el-select clearable style="width:177px"
                             v-model="queryForm.menuType" placeholder="请选择">
                      <el-option :label="item.value" :value="item.key" v-for="(item,index) in productStatusEnumList" :key="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppAppMenuList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppAppMenu"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppAppMenu(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppAppMenu(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppAppMenuList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppAppMenuList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="menuName"
        label="名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="menuType"
        label=" 类型"
        min-width="180"
      >
          <template slot-scope="scope">
              {{ reutrnStatus(scope.row.menuType) }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="menuIcon"
        label="图标"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="menuLink"
        label="链接"
        min-width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="permission"-->
<!--        label="权限"-->
<!--        min-width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="remarks"
        label="备注"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppAppMenu(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppAppMenu(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppAppMenu(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppAppMenuStates[mppAppMenuState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppAppMenu"
          ref="mppAppMenuForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="名称"
            prop="menuName"
          >
            <el-input
              size="small"
              v-model="mppAppMenu.menuName"
              :disabled="mppAppMenuState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=" 类型"
            prop="menuType"
          >
            <!-- <el-input
              size="small"
              v-model="mppAppMenu.menuType"
              :disabled="mppAppMenuState == 'check'"
            ></el-input> -->
            <el-select clearable style="width:177px" :disabled="mppAppMenuState == 'check'"
                v-model="mppAppMenu.menuType" placeholder="请选择">
                <el-option :label="item.value" :value="item.key" v-for="item,index in productStatusEnumList" :key="item.key"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="图标"
            prop="menuIcon"
          >
            <el-input
              size="small"
              v-model="mppAppMenu.menuIcon"
              :disabled="mppAppMenuState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="链接"
            prop="menuLink"
          >
            <el-input
              size="small"
              v-model="mppAppMenu.menuLink"
              :disabled="mppAppMenuState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="权限"-->
<!--            prop="permission"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppAppMenu.permission"-->
<!--              :disabled="mppAppMenuState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              v-model="mppAppMenu.sort"
              :disabled="mppAppMenuState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="remarks"
          >
            <el-input
              size="small"
              v-model="mppAppMenu.remarks"
              :disabled="mppAppMenuState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppAppMenuState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppAppMenuList();
                    this.getMppAppMenuList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppAppMenuList();
                    this.getMppAppMenuList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     menuName: '', //名称
                     menuType: '', // 类型
                     menuIcon: '', //图标
                     menuLink: '', //链接
                     permission: '', //权限
                     sort: '', //排序
                     remarks: '', //备注
                     createTime: '', //创建时间
                },
                productStatusEnumList:[],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppAppMenuState: 'add',
                mppAppMenuStates: {
                    add: '新建菜单',
                    check: '查看菜单',
                    edit: '修改菜单'
                },

                multipleSelection: [],
                mppAppMenuList: [],
                mppAppMenu: {
                    menuName: '', //名称
                    menuType: '', // 类型
                    menuIcon: '', //图标
                    menuLink: '', //链接
                    permission: '', //权限
                    sort: '', //排序
                    remarks: '', //备注
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    menuName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                    menuType: [{ required: true, message: ' 类型不能为空', trigger: 'blur' }],
                    menuIcon: [{ required: true, message: '图标不能为空', trigger: 'blur' }],
                    menuLink: [{ required: true, message: '链接不能为空', trigger: 'blur' }],
                    permission: [{ required: true, message: '权限不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppAppMenuList();
            this.getProductStatusEnum();
        },
        methods: {
            // 获取商品状态枚举
            getProductStatusEnum() {
              get('/mpp/utils/getEnum', {
                enumType: 'app_menu_type_shop',
              }).then((res) => {
                if (res.success) {
                  this.productStatusEnumList = res.enumList
                  console.log(this.productStatusEnumList)
                }
              })
            },
            reutrnStatus(key){
                for (let i = 0; i < this.productStatusEnumList.length; i++) {
                    if(this.productStatusEnumList[i].key == key){
                        return this.productStatusEnumList[i].value
                    }
                }
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppAppMenuList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppAppMenuList = [];
            },
            resetDialog() {
                this.mppAppMenuState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      menuName: '', //名称
                      menuType: '', // 类型
                      menuIcon: '', //图标
                      menuLink: '', //链接
                      permission: '', //权限
                      sort: '', //排序
                      remarks: '', //备注
                      createTime: '', //创建时间
                };
                this.getMppAppMenuList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppAppMenu = {
                      menuName: '', //名称
                      menuType: '', // 类型
                      menuIcon: '', //图标
                      menuLink: '', //链接
                      permission: '', //权限
                      sort: '', //排序
                      remarks: '', //备注
                      createTime: '', //创建时间
                };
            },
            submitForm() {
                if (this.mppAppMenuState == 'add') {
                    this.$refs.mppAppMenuForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/appmenu/add`,{ ...this.mppAppMenu }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppAppMenuList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppAppMenuState == 'edit') {
                    this.$refs.mppAppMenuForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/appmenu/edit`,{ ...this.mppAppMenu }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppAppMenuList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppAppMenu() {
                this.showDialog = true;
                this.mppAppMenuState = 'add';
            },
            checkMppAppMenu(mppAppMenuId) {
                console.log(mppAppMenuId);
                this.currentMppAppMenuId = mppAppMenuId;

                this.getMppAppMenuById();
                this.showDialog = true;
                this.mppAppMenuState = 'check';
            },
            editMppAppMenu(mppAppMenuId) {
                console.log('mppAppMenu', mppAppMenuId);
                if (mppAppMenuId) {
                    this.currentMppAppMenuId = mppAppMenuId;
                    this.getMppAppMenuById();
                } else {
                    this.mppAppMenu = { ...this.mppAppMenu, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppAppMenuState = 'edit';
            },
            deleteMppAppMenu(mppAppMenuId) {
                let ids = '';
                if (mppAppMenuId) {
                    ids = mppAppMenuId;
                } else {
                    ids = this.multipleSelection.map((mppAppMenu) => mppAppMenu.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/appmenu/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAppMenuList();
                                this.getMppAppMenuList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppAppMenuList() {
                this.resetMppAppMenuList();
                this.getMppAppMenuList();
            },
            getMppAppMenuList(query = {}) {
                this.loading = true;
                get(`/mpp/appmenu/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppAppMenuList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppAppMenuById() {
                get(`/mpp/appmenu/get`,{ id: this.currentMppAppMenuId }).then((res) =>{
                    if(res.success){
                      this.mppAppMenu = { ...this.mppAppMenu, ...res.mppAppMenu };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppAppMenuList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/appmenu/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/appmenu/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/appmenu/importData`,formData);
              this.refreshMppAppMenuList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppAppMenuList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppAppMenuList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>